import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import ProductList from './widgets/ProductList'
import { Link } from 'react-router-dom'
import {
  PRODUCT_LIST_PAGE_LOADED,
  PRODUCT_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import _ from 'lodash'
const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: PRODUCT_LIST_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: PRODUCT_LIST_PAGE_UNLOADED }),
})

class ProductManage extends React.Component {
  constructor() {
    super();
  }
  componentWillMount() {
    if (this.props.currentUser) {
      const payload = agent.Products.getProducts(this.props.currentUser.key)
      this.props.onLoad(payload);
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  render() {
    if (!this.props.products) {
      return (
        <Loading />
      )
    }
    let products = this.props.products
    products = _.orderBy(products, ['name'], ['asc'])

    return (
      <div>
        <Header selected={'settings'} />
        <CrumbBox data={[{ key: 'Manage Product' }]} rootKey='/settings' rootVal='Settings' />
        <div id="main"><div id="main-wrap">
          <div id="content">
            <Link className='HeaderButton' to='/products/add'>Add</Link>
            <h2>Manage Products</h2>
            <ProductList data={products} mode={'edit'} />
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductManage)
